import React, { Fragment } from 'react';

const isDev = (process.env.REACT_APP_FIREBASE_ENV == 'development');

export function attachment_fields(assetTypeId) {

	return (
		{
			name: '',
			expiration: null,
			alertThreshold: '0',
			images: [],
		}
	);
}
export function attachment_form_layout({
	attachment, 
	expires,
	firebase, 
	handle, 
	handleReorder,
	invoice,
	isDefault,
}) {

	var altImages = [];

	for (let index = 1; index < ((attachment.images?.length ?? 0) + 1) ; index++) {
		altImages.push({
			grid: 'col-sm-6 col-md-12 col-xl-6 mt-3',
			label: '',
			field: 'imageUrl' + index,
			type: 'dropzone',
			hasCaption: true,
			// disabled: (!attachment.imageUrl),
			dropzone: {
				accept: 'image/png, image/jpeg, application/pdf',
				camera: true,
				storage: 'firebase',
				storageRef: firebase.storage().ref(),
				bin: handle,
				directory: 'assets',
				className: 'mb-3',
				height: "180px",
				multiple: true,
				addButtons: false,
				resultsArray: true,
				onPromote: handleReorder,
			}
		});
	}

	return (
		[{
			column_class: 'col-xl-12',
			body: [{
				section:
					<Fragment>
						<h3 className="m-t-none m-b">Attachment Details</h3>
					</Fragment>,
				layout: [{
					grid: 'col-12',
					label: 'Vendor Name',
					field: 'name',
					type: 'text',
					readOnly: isDefault,
					valid: ['required']
				}, {
					grid: 'col-12',
					label: 'Price',
					field: 'price',
					prepend: '$',
					type: (invoice) ? 'usd' : 'skip',
					valid: ['required']
				}, {
					grid: 'col-md-6',
					label: 'Expiration Date',
					field: 'expiration',
					type: (expires) ? 'date' : 'skip',
					clearButton: true,
				}, {
					grid: 'col-md-6',
					label: 'Alert Threshold',
					field: 'alertThreshold',
					type: (expires) ? 'select' : 'skip',
					options:
						<Fragment>
							<option value="0">No Alert</option>
							<option value="7">7 days</option>
							<option value="30">30 days</option>
							<option value="60">60 days</option>
						</Fragment>,
				}],
			}],
		}, {
			column_class: 'col-xl-12',
			body: [{
				section:
					<Fragment>
						<h3 className="m-t-none m-b">Attachment File</h3>
					</Fragment>,
				layout: [{
					grid: 'col-12',
					label: 'Attachment File',
					field: 'imageUrl0',
					type: 'dropzone',
					hasCaption: true,
					dropzone: {
						accept: 'image/png, image/jpeg, application/pdf',
						camera: true,
						storage: 'firebase',
						storageRef: firebase.storage().ref(),
						bin: handle,
						directory: 'assets',
						className: 'mb-3',
						height: "280px",
						multiple: true,
						addButtons: false,
					}
				}],
			}, {
				section:
					<Fragment>
						<h3 className="m-t-none mb-0">Additional Files</h3>
					</Fragment>,
				layout: [ ...(altImages) ],
			}],
		}]
	);
}